import { ExamLocationVerdict } from '@exam-center/graphql';
import { Label, LabelColor } from '@shared/components';

export const VERDICT_RESULT_COLOR: Readonly<Record<ExamLocationVerdict, LabelColor>> = {
  APPROVED: LabelColor.SUCCESS,
  REJECTED: LabelColor.ERROR,
};

export const VERDICT_RESULT_TEXT: Readonly<Record<ExamLocationVerdict, string>> = {
  [ExamLocationVerdict.Approved]: 'อนุมัติคำขอ',
  [ExamLocationVerdict.Rejected]: 'ไม่อนุมัติ',
};

interface VerdictResultLabelProps {
  variant: ExamLocationVerdict;
}

export default function VerdictStatusLabel(props: Readonly<VerdictResultLabelProps>) {
  const { variant } = props;

  return (
    <Label
      color={VERDICT_RESULT_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {VERDICT_RESULT_TEXT[variant]}
    </Label>
  );
}
